import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Guía de Polarizado Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/tANVC56Ssk58UaefvQNkPT/Bono_1.webp'
  }, {
    title: 'Guía de Ploteo Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/gTeiMneZ4ARtSneem9gzeF/Bono_2.webp'
  }, {
    title: 'Guía Completa de Mecánica Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/aQXKyK81WqD4uisTE5eqUg/Bono_3.webp'
  }, {
    title: 'Guía para Presupuestar Detailing Automotriz',
    image: 'https://cdn.magicpatterns.com/uploads/brf7ftLNxB4XUPxM4jTrP1/Bono_4.webp'
  }, {
    title: 'Emprendé en Detallado Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/t2urQdFCA8LKEipf4CB4mq/Bono_5.webp'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-[#0a0a0a] to-[#111] pt-[44px] pb-[44px]" data-id="element-17">
      <div className="max-w-6xl mx-auto pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px]" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-19">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-20">
            + 5 BONOS <span className="text-brand-yellow" data-id="element-21">INCLUIDOS</span>
          </h2>

          <div className="relative inline-flex items-center gap-3 bg-black/40 backdrop-blur-md px-6 py-2.5 rounded-full border border-brand-yellow/30 shadow-[0_0_30px_rgba(245,197,24,0.15)] group overflow-hidden" data-id="element-22">
            {/* Animated background shine */}
            <div className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-brand-yellow/20 to-transparent -skew-x-12 -translate-x-full group-hover:animate-[shine_2s_infinite] pointer-events-none" style={{
            animation: 'shine 3s infinite'
          }} data-id="element-23" />

            {/* Inner glow */}
            <div className="absolute inset-0 bg-gradient-to-b from-brand-yellow/5 to-transparent pointer-events-none" data-id="element-24" />

            <Sparkles className="w-4 h-4 text-brand-yellow animate-pulse" data-id="element-25" />
            <p className="text-xs md:text-sm font-black text-white uppercase tracking-[0.15em] whitespace-nowrap relative z-10 drop-shadow-sm" data-id="element-26">
              GRATIS{' '}
              <span className="text-brand-yellow" data-id="element-27">POR EL DÍA DE HOY</span>
            </p>
            <Sparkles className="w-4 h-4 text-brand-yellow animate-pulse" data-id="element-28" />

            {/* Subtle outer pulse ring */}
            <div className="absolute inset-0 rounded-full border border-brand-yellow/20 animate-ping opacity-20 pointer-events-none" data-id="element-29" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-30">
          {bonuses.map((bonus, index) => <motion.a key={index} href="#compra" onClick={e => {
          e.preventDefault();
          document.querySelector('#compra')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.05
        }} className="group cursor-pointer" data-id="element-31">
              <div className="bg-[#1a1a1a] rounded-2xl overflow-hidden border border-gray-800 hover:border-brand-yellow/50 transition-all duration-300 shadow-lg hover:shadow-brand-yellow/20 hover:scale-105" data-id="element-32">
                {bonus.image ? <div className="aspect-[3/4] overflow-hidden flex items-center justify-center bg-[#111]" data-id="element-33">
                    <img src={bonus.image} alt={bonus.title} width={300} height={400} loading="lazy" className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500 p-4" data-id="element-34" />
                  </div> : <div className="aspect-square bg-gradient-to-br from-brand-yellow/20 to-brand-gold/10 flex items-center justify-center" data-id="element-35">
                    <Sparkles className="w-24 h-24 text-brand-yellow" data-id="element-36" />
                  </div>}
                <div className="p-6 flex flex-col items-center text-center sm:items-start sm:text-left" data-id="element-37">
                  <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 mb-4" data-id="element-38">
                    <div className="bg-green-500 text-white text-xs font-black px-3 py-1.5 rounded-full flex-shrink-0 mt-1" data-id="element-39">
                      BONO {index + 1}
                    </div>
                    <p className="text-lg font-bold text-white leading-tight" data-id="element-40">
                      {bonus.title}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 mt-auto pt-2 border-t border-gray-800/50 w-full justify-center sm:justify-start" data-id="element-41">
                    <span className="text-xs text-gray-500 line-through font-medium" data-id="element-42">
                      $19.990
                    </span>
                    <span className="text-sm font-black text-green-400 bg-green-400/10 px-2 py-0.5 rounded-md border border-green-400/20 animate-pulse" data-id="element-43">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </motion.a>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto text-center bg-[#111]/50 backdrop-blur-sm py-6 px-8 rounded-2xl border border-brand-yellow/20 relative overflow-hidden group" data-id="element-44">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-yellow/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" data-id="element-45" />
          <p className="text-lg md:text-xl font-bold text-white/90 relative z-10 tracking-tight" data-id="element-46">
            Todo lo que necesitás para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-yellow via-brand-gold to-brand-yellow font-black" data-id="element-47">
              empezar y crecer
            </span>
          </p>
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-brand-yellow/50 to-transparent" data-id="element-48" />
        </motion.div>
      </div>
    </section>;
}